export const LABELS = {
  EMAIL: 'Email',
  EMAIL_ADDRESS: 'Email address',
  FIRST_NAME: 'First name',
  GIVEN_NAME: 'Given name',
  LAST_NAME: 'Last name',
  MEDICARE_NUMBER: 'Medicare number',
  MEDICARE_CARD_EXPIRY_DATE: 'Medicare card expiry date',
  PHONE_NUMBER: 'Phone number',
  PASSPORT_NUMBER: 'Passport number',
  SEX: 'Sex',
  TITLE: 'Title',
  SCALE: 'Who is this cover for?',
  DATE_OF_BIRTH: 'Date of birth',
  PAYMENT_FREQUENCY: 'Payment frequency',
  PAYMENT_START_DATE: 'Payment start date',
  DATE_INPUT: 'Select date',
  ADD_PARTNER_RADIO: 'Do you want to add a partner to your cover?',
  HOSPITAL_EXCESS: 'Hospital excess',
  STUDENT_DEPENDANT: 'Are they a student dependant? ',
  STUDENT_GRADUATION_DATE: 'Expected graduation date',
  TRANSFERRING_FUNDS_RADIO: 'Do you currently have health insurance?',
  TRANSFERRING_FUNDS_INFO_BOX: "Let us know your previous insurer's details and any waiting periods already served may be recognised so you can claim straight away.",
  TRANSFERRING_FUNDS_SUB_HEADING: 'Insurer details',
  CURRENT_PROVIDER: 'Current or last health insurer',
  MEMBER_NUMBER: 'Policy number',
  FULL_NAME: 'Full name',
  COUNTRY: 'Main country of citizenship',
  VISA_SUBCLASS: 'Visa subclass',
  COVER_START_DATE: 'Cover start date',
  VISA_END_DATE: 'Expected visa end date',
  STATE: 'State',
  STREET_ADDRESS: 'Street address',
  STREET_ADDRESS2: 'Street address 2',
  SUBURB: 'Suburb',
  POST_CODE: 'Postcode',
  ADDRESS_LOOKUP: 'Address',
  AUS_MAILING_ADDRESS_RADIO: 'Do you have an Australian mailing address?',
  PREEXISTING_CONDITIONS: 'Have you, or anyone covered under the policy, been affected by any of the following pre-existing conditions?',
  PAYMENT_METHOD: 'Payment method',
  ACCOUNT_NAME: 'Account name',
  ACCOUNT_NUMBER: 'Account number',
  BSB: 'BSB',
  DIRECT_DEBIT_TITLE: 'Authorise direct debit',
  DIRECT_DEBIT_LABEL_DIRECT_DEBIT: 'I/we authorise nib (userid 000488) to debit my/our account via BECS (Bulk Electronic Clearing System) in accordance with the specified payment frequency and agree to the terms and conditions of the direct debit request service agreement.',
  DIRECT_DEBIT_LABEL_DIRECT_DEBIT_ARHI: 'I have read and agree to the Direct Debit Service Agreement.',
  DIRECT_DEBIT_LABEL_CREDIT_CARD: 'I have read and accept the direct debit request service agreement.',
  DIRECT_DEBIT_CREDIT_CARD_LABEL_ARHI: 'I agree to being charged in line with the amount and payment frequency specified in my online application.',
  FUND_RULES_HEADING: 'Review and submit',
  FUND_RULES_DESCRIPTION: 'Please read through the following information:',
  FUND_RULES_FIELD_LABEL: 'Confirmation',
  DEPENDANTS_RADIO: 'Do you want to add a dependant child or student to your cover?',
  CREDIT_CARD_NUMBER: 'Card number',
  CREDIT_CARD_EXPIRY_DATE: 'Expiry date',
  CREDIT_CARD_NAME_ON: 'Name on card',
  PARTNER_TRANSFERRING_FUNDS_RADIO: 'Does your partner currently have private health insurance?',
  CHILD_TRANSFERRING_FUNDS_RADIO: 'Does your dependant currently have private health insurance?',
  PARTNER_TRANSFERRING_FUNDS_SUB_HEADING: 'Insurer details',
  PARTNER_TRANSFERRING_FUNDS_PROVIDER_LABEL: 'Fund you are transferring from',
  PARTNER_TRANSFERRING_FUNDS_PROVIDER_LABEL_ARHI: 'Current or last health insurer',
  PARTNER_TRANSFERRING_FUNDS_MEMBER_NUMBER_LABEL: 'Policy number',
  MEDICARE_ALL_COVERED_RADIO_LABEL: 'Are all people on the policy eligible for Medicare?',
  COVERED_BY_POLICY: 'Are you covered by this policy?',
  PROMO_CODE: 'Promo code',
  DECLARATION: 'Declaration',
  DECLARATION_DESCRIPTION: 'Do you declare that the information that you have provided is complete and correct? Do you understand that giving false or misleading information is a serious offence?',
  PRIVACY_POLICY_AGREEMENT_TITLE: 'Your Privacy',
  PRIVACY_POLICY_AGREEMENT_DESCRIPTION: 'Please read through the following information:',
  PRIVACY_POLICY_AGREEMENT_DESCRIPTION_APIA: 'Apia Health Insurance is underwritten by the nib Group.',
  PRIVACY_POLICY_AGREEMENT_DESCRIPTION_ING: 'ING Health Insurance is underwritten by the nib Group.',
  PRIVACY_POLICY_AGREEMENT_FIELD_LABEL: 'Confirmation',
  PRIVACY_POLICY_AGREEMENT_FIELD_LABEL_AGREEMENT: 'I have read and agree to the Privacy Policy and agree to nib collecting and using my personal information to issue and manage my policy. I understand nib or one of their partners may contact me to discuss my quote.',
  PRIVACY_POLICY_AGREEMENT_FIELD_LABEL_AGREEMENT_GU: 'I have read and agree to the Privacy Policy and agree to GU Health collecting and using my personal information to issue and manage my policy.',
  PRIVACY_POLICY_AGREEMENT_FIELD_LABEL_AGREEMENT_APIA: "I have read and agree to Apia's Privacy Policy and nib's Privacy Policy and agree to my personal information being collected and used to issue and manage my policy.",
  PRIVACY_POLICY_AGREEMENT_FIELD_LABEL_AGREEMENT_ING: "I have read and agree to ING's Privacy Policy and nib's Privacy Policy and agree to my personal information being collected and used to issue and manage my policy.\n\nI understand ING Bank (Australia) Limited (ING) must undertake due diligence and name screening of individuals applying for or holding an ING Insurance product and that this is an ING eligibility requirement. ING may screen prior to membership confirmation, and periodically, on all policy-holders. If ING is not able to complete this assessment to its satisfaction, a membership will not be issued and/or a policy may not be renewed.",
  EDUCATION_INSTITUTION: 'Educational institution'
};
export const PARTNER_TRANSFERRING_FUNDS_INFO_BOX = ["Add your partner's current health fund's details so we can cancel their current policy and get their transfer certificate. This will mean we can recognise waiting periods your partner has already served and check remaining limits on their included services.", "If you don't provide these details, you will need to cancel your partner's current cover and provide us with a transfer certificate. This could delay your ability to claim under your new cover."];
export const DEFAULT_MASK = value => value.split('').map(() => /./);
export const FUNNELS = {
  ARHI: 'ARHI',
  APIA: 'APIA',
  GU: 'GU',
  IMAN: 'IMAN',
  ISHI: 'ISHI',
  IWHI: 'IWHI',
  IAP: 'IAP',
  ING: 'ING',
  SUNCORP: 'SUNCORP',
  AAMI: 'AAMI',
  PRICELINE: 'PRICELINE',
  REAL: 'REAL',
  SENIORS: 'SENIORS',
  NIBP2PWEB: 'NIBP2PWEB',
  CORPORATE: 'CORPORATE',
  GUHEALTH: 'GUHEALTH'
};
export const ARHI_RESIDENTIAL_FUNNELS = {
  ARHI: 'ARHI',
  APIA: 'APIA',
  ING: 'ING',
  SUNCORP: 'SUNCORP',
  AAMI: 'AAMI',
  PRICELINE: 'PRICELINE',
  REAL: 'REAL',
  SENIORS: 'SENIORS',
  NIBP2PWEB: 'NIBP2PWEB',
  CORPORATE: 'CORPORATE',
  GUHEALTH: 'GUHEALTH'
};
export const PHONE_NUMBERS = {
  ARHI: '13 16 42',
  APIA: '13 50 50',
  GU: '13 16 42',
  IMAN: '1800 221 133',
  IWHI: '1800 775 204',
  ISHI: '1800 775 204',
  ING: '1800 111 831',
  SUNCORP: '13 11 55',
  AAMI: '13 22 44',
  PRICELINE: '1300 070 761',
  IAP: '+61 296 924 482'
};
export const EMAIL = {
  ARHI: 'oshcteam@nib.com.au',
  IAP: 'oshcteam@nib.com.au'
};
export const CONTINUOUS_COVER_OPTIONS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  '10': '10+'
};
export const CONTINUOUS_COVER_OPTIONS_MOBILE = {
  '0': '0 (Less than one year)',
  '1': '1 year',
  '2': '2 years',
  '3': '3 years',
  '4': '4 years',
  '5': '5 years',
  '6': '6 years',
  '7': '7 years',
  '8': '8 years',
  '9': '9 years',
  '10': '10+ years'
};
export const INTERNATIONAL_FUNNELS = [FUNNELS.IMAN, FUNNELS.ISHI, FUNNELS.IWHI, FUNNELS.IAP];
export const MIN_ADULT_DEPENDANT_AGE = 21;
export const MAX_ADULT_DEPENDANT_AGE_25 = 25;
export const MAX_ADULT_DEPENDANT_AGE_31 = 31;
export const getFormControlType = (required, optional) => {
  if (required) {
    return 'required';
  }
  if (optional) {
    return 'optional';
  }
  return;
};